<template>
  <ranking-page
    endpoint="/spontan/ranking/total/counts/finn"
    heading-danish="Rangliste - FiNN-tællinger i alt"
    heading-english="Ranking - Total FiNN counts"
    is-finn
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
